import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import Themes from "./themes/themes";
import "./src/config";
import CustomFunctions from "./modules/functions";
import ErrorPage from "./themes/cosmote/templates/errorPage";
import Functions from "./src/functions";

function isPageReload() {
	const [nav] = performance.getEntriesByType("navigation");
	if (nav) {
		return nav.type === "reload";
	}
	// legacy fallback
	return (
		typeof performance.navigation !== "undefined" &&
		performance.navigation.type === 1
	);
}

const currentPath = window.location.pathname;
const shouldRedirectToHome =
	currentPath !== "/" && currentPath !== "" && isPageReload();

if (shouldRedirectToHome) {
	window.location.replace("/");
} else {
	function init() {
		const url = CustomFunctions.restAPI("/page/land");
		sessionStorage.clear();
		fetch(url, {})
			.then((res) => res.json())
			.then((data) => {
				if (data.messageCode && data.messageCode === "MissingHeaders") {
					ReactDOM.render(
						<ErrorPage wifi={true} />,
						document.getElementById("root"),
					);
				} else {
					if (data.contractInfoCarrier.roamer) {
						window.location.href = String(data.abroadUrl);
					} else if (data.contractInfoCarrier.touristPack) {
						window.location.href = String(data.abroadUrl);
					}
					sessionStorage.setItem("landPageData", JSON.stringify(data));
					let residential = [
						"POSTR",
						"PREPAID_FROG",
						"PREPAID_COSMOKARTA",
						"NEO",
						"PREPAID_WHATSUP",
						"HYBRID_RESIDENTIAL_COST_CONTROL",
						"PREPAID_NA",
						"TOURIST",
						"POSTW",
						"NINJAW",
					];
					let business = [
						"HYBRID_BUSINESS_COST_CONTROL",
						"POSTB",
						"POSTB_SPLIT",
						"NA",
					];
					sessionStorage.setItem("residential", JSON.stringify(residential));
					sessionStorage.setItem("business", JSON.stringify(business));

					let theme = "";
					if (data.contractInfoCarrier.hasLPService && !data.hadPending) {
						if (data.contractInfoCarrier.inListOfWhatuspCss) {
							theme = "whatsUp";
						} else {
							if (
								data.contractInfoCarrier.customerSegment === "PREPAID_WHATSUP"
							) {
								theme = "whatsUp";
							} else if (
								data.contractInfoCarrier.customerSegment === "POSTB" ||
								data.contractInfoCarrier.customerSegment === "POSTB_SPLIT" ||
								data.contractInfoCarrier.customerSegment ===
									"HYBRID_BUSINESS_COST_CONTROL" ||
								data.contractInfoCarrier.customerSegment === "POSTR" ||
								data.contractInfoCarrier.customerSegment ===
									"PREPAID_COSMOKARTA" ||
								data.contractInfoCarrier.customerSegment ===
									"HYBRID_RESIDENTIAL_COST_CONTROL" ||
								data.contractInfoCarrier.customerSegment === "IOTG" ||
								data.contractInfoCarrier.customerSegment === "NEO"
							) {
								theme = "cosmote";
							} else {
								theme = "frog";
							}
						}
					} else if (!data.contractInfoCarrier.hasLPService) {
						if (data.contractInfoCarrier.inListOfWhatuspCss) {
							theme = "whatsUp";
						} else {
							if (
								data.contractInfoCarrier.customerSegment === "PREPAID_WHATSUP"
							) {
								theme = "whatsUp";
							} else if (
								data.contractInfoCarrier.customerSegment === "POSTB" ||
								data.contractInfoCarrier.customerSegment === "POSTB_SPLIT" ||
								data.contractInfoCarrier.customerSegment ===
									"HYBRID_BUSINESS_COST_CONTROL" ||
								data.contractInfoCarrier.customerSegment === "POSTR" ||
								data.contractInfoCarrier.customerSegment ===
									"PREPAID_COSMOKARTA" ||
								data.contractInfoCarrier.customerSegment ===
									"HYBRID_RESIDENTIAL_COST_CONTROL" ||
								data.contractInfoCarrier.customerSegment === "IOTG"
							) {
								theme = "cosmote";
							} else {
								theme = "frog";
							}
						}
					}

					const FW_Router = Themes[theme]["router"];

					ReactDOM.render(
						<BrowserRouter>
							<FW_Router />
						</BrowserRouter>,
						document.getElementById("root"),
					);
				}
			})
			.catch((error) => {
				window.location.replace("/error");
			});
	}
	if (Functions.getQueryPath(1) !== "error") {
		init();
	} else {
		ReactDOM.render(
			<ErrorPage wifi={false} />,
			document.getElementById("root"),
		);
	}
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
